<template>
  <div class="body">
    <div id="material-kit">
      <div class="wrapper">
        <div :class="{ 'nav-open': NavbarStore.showNavbar }">
          <router-view
            name="header"
            v-on:setCurrentStep="setCurrentStep($event)"
          />
          <div>
            <router-view
              v-bind:userID="userID"
              v-bind:project="project"
              v-bind:region="region"
              v-bind:videos="videos"
              v-bind:currentStep="currentStep"
              v-bind:croppingWindow="croppingWindow"
              v-bind:uploadParams="uploadParams"
              v-bind:predictionParams="predictionParams"
              v-on:updateVideos="videos = $event"
              v-on:increaseCurrentStep="increaseCurrentStep"
            />
          </div>
          <div class="push"></div>
        </div>
      </div>
      <router-view name="footer" v-on:setCurrentStep="setCurrentStep($event)" />
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "App",
  data() {
    return {
      userID: "",
      project: "",
      region: "",
      videos: [],
      currentStep: 0,
      croppingWindow: {
        x: null,
        y: null,
        width: null,
        height: null,
        image: "https://miro.medium.com/max/1158/1*9EBHIOzhE1XfMYoKz1JcsQ.gif",
        imageIsLoaded: false
      },
      uploadParams: {
        videoCount: 0,
        totalUploadSize: 0,
        totalUploadCount: 0
      },
      predictionParams: {
        predictionRate: 5
      }
    };
  },
  methods: {
    increaseCurrentStep() {
      this.currentStep += 1;
    },
    setCurrentStep(value) {
      this.currentStep = value;
    },
    async getUUID() {
      let vm = this;
      await $.get("/get_UUID", function(data) {
        vm.userID = data;
      });
    },
    async getProjectInfo() {
      let vm = this;
      await $.get("/get_project_info", function(data) {
        vm.project = data.project;
        vm.region = data.region;
      });
    }
  },
  created() {
    document.title = "deepMTJ.org";
    this.getUUID();
    this.getProjectInfo();
  },
  destroyed() {}
};
</script>

<style scoped>
.push {
  height: 90px;
}
.wrapper {
  min-height: 100%;
  margin-bottom: 0;
}
</style>
